class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    window.addEventListener('prodigy:cart-drawer:open', () => { this.open() });
    window.addEventListener('prodigy:cart-drawer:close', () => { this.close() });

    window.addEventListener('prodigy:cart:reloaded', (e) => {
      let cartDrawerSliders = document.querySelectorAll('cart-drawer [data-slider]');
      let freeShippingBar = document.querySelector('[data-block-type="free_shipping_bar"]');
      let discountCodeInput = document.querySelector(`cart-drawer ${theme.cart.selectors.discounts.codeInput}`);
      let scrollAnimationsEnabled = document.body.hasAttribute('data-scroll-animations-enabled');

      if(cartDrawerSliders){
        cartDrawerSliders.forEach(cartDrawerSlider => {
          theme.sliders.initSlider(cartDrawerSlider, cartDrawerSlider.dataset.sectionId);
        });
        theme.products.init();
      }

      if(freeShippingBar){
        theme.cart.updateFreeShipping(e.detail.cart);
      }

      if(discountCodeInput){
        theme.cart.applyDiscountButton();
        theme.cart.removeDiscountButtons();
      }

      if(scrollAnimationsEnabled){
        theme.scrollAnimations.createAnimationObservers();
      }

      if( e.detail.cart.item_count === 0 ){
        document.body.setAttribute('data-cart-empty', '');
      }else{
        document.body.removeAttribute('data-cart-empty');
      }
    });

    window.addEventListener('prodigy:add-to-cart:success', (e) => {
      let cartDrawerSliders = document.querySelectorAll('cart-drawer [data-slider]');
      let scrollAnimationsEnabled = document.body.hasAttribute('data-scroll-animations-enabled');
      let discountCode = document.querySelectorAll('cart-drawer [data-block-type="discount_code"]')

      if(cartDrawerSliders){
        cartDrawerSliders.forEach(cartDrawerSlider => {
          theme.sliders.initSlider(cartDrawerSlider, cartDrawerSlider.dataset.sectionId);
        });
      }

      if(scrollAnimationsEnabled){
        theme.scrollAnimations.createAnimationObservers();
      }

      if(discountCode){
        theme.cart.applyDiscountButton();
        theme.cart.removeDiscountButtons();
      }

      theme.accordions.init();

      document.body.removeAttribute('data-cart-empty');
    });

    window.dispatchEvent(new CustomEvent('prodigy:cart-drawer:loaded'));
  }

  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll(`#cart-icon-bubble, ${theme.cart.selectors.floatingCartIcon.button}`);

    cartLinks.forEach(cartLink => {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        if( !document.body.classList.contains('template--cart') ){
          event.preventDefault();
          this.open(cartLink);
        }
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    })

  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    document.body.classList.add('cart-drawer--open');

    window.dispatchEvent(new CustomEvent('prodigy:cart-drawer:opened'))
  }

  close() {
    this.classList.remove('active');
    theme.utils.removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('cart-drawer--open');

    window.dispatchEvent(new CustomEvent('prodigy:cart-drawer:closed'))
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState, shouldOpen = true) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('.drawer__overlay').addEventListener('click', this.close.bind(this));
      if(shouldOpen){
        this.open();
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    const sectionsToRender = [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];

    if( document.querySelector(theme.cart.selectors.floatingCartIcon.button) ){
      sectionsToRender.push(
        {
          id: 'floating-cart-icon',
          section: 'floating-cart-icon',
          selector: theme.cart.selectors.floatingCartIcon.button
        }
      );
    }

    return sectionsToRender;
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    const sectionsToRender = [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: 'cart-drawer-items'
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__footer'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];

    if( document.querySelector(theme.cart.selectors.floatingCartIcon.button) ){
      sectionsToRender.push(
        {
          id: 'floating-cart-icon',
          section: 'floating-cart-icon',
          selector: theme.cart.selectors.floatingCartIcon.button
        }
      )
    }

    return sectionsToRender;
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
